<template>
  <div class="nittyoku">
    <h3>日直</h3>
    <div class="multi-date-table" v-for="(item, index) in form.nittyoku" :key="index">
      <div class="head"><b>日直{{ (index + 1) }}</b></div>
      <div class="flex">
          <b class="width-115">取得日</b>
          <p>{{ item.shinsei_date }}</p>
      </div>
      <div class="flex">
          <b class="width-115">就業場所</b>
          <p>{{ form.syuugyou_basyo_name }}</p>
      </div>
    </div>
    <div class="col-item">
      <b class="title">備考</b>
      <p class="pre">{{ form.notes ?? '無し' }}</p>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'
import { Shinsei } from '@/types/Shinsei';

export default defineComponent({
  props: {
    form: {
      type: Object as () => Shinsei,
      default: null
    },
  },
  setup() {

    return {
    };
  },
  components: {

  }
})

</script>
<style lang="scss" scoped>
@import '@scss/components/shinsei-detail.scss';
</style>
